import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Button from "components/CustomButtons/Button.js";
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import {withSnackbar} from "notistack";
import {exchangeUserInvitation} from "../../utils/request";

const styles = (theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(2),
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
});

const DialogTitle = withStyles(styles)((props) => {
	const {children, classes, onClose, ...other} = props;
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
					<CloseIcon/>
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
});

const DialogContent = withStyles((theme) => ({
	root: {
		padding: theme.spacing(2),
	},
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(1),
	},
}))(MuiDialogActions);

class UserChangeDialog extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			open: this.props.open
		}
	}


	toShowExchangeSubmitProme = () => {
		if (this.props.userInvitationCountEffective < 1) {
			this.props.enqueueSnackbar('数量不足, 无法兑换', {
					variant: 'error',
				}
			)
		} else {
			this.props.enqueueSnackbar('正在申请中...', {
					variant: 'success',
				}
			);
			this.handleClose();

			exchangeUserInvitation("prome").then(res => {

				switch (res.data) {
					case  "-1":
						this.props.enqueueSnackbar("未知错误, 请重复尝试, 如果此问题依然存在, 请联系我们解决", {
								variant: 'error',
							}
						);
						break;
					case "1":
						this.props.enqueueSnackbar('优惠码兑换成功', {
								variant: 'success',
							}
						);
						this.props.updateUserInfo();
						this.handleClose();
						break;
					case "2":
						this.props.enqueueSnackbar("数量不足, 无法兑换", {
								variant: 'error',
							}
						);
						break;
				}
			})
		}

	};

	toShowExchangeSubmitCash = () => {

		if (this.props.userInvitationCountEffective < 3) {
			this.props.enqueueSnackbar('数量不足, 无法兑换', {
					variant: 'error',
				}
			)
		} else {
			this.props.enqueueSnackbar('正在申请中...', {
					variant: 'success',
				}
			);
			this.handleClose();

			exchangeUserInvitation("cash").then(res => {

				switch (res.data) {
					case  "-1":
						this.props.enqueueSnackbar("未知错误, 请重复尝试, 如果此问题依然存在, 请联系我们解决", {
								variant: 'error',
							}
						);
						break;
					case "1":
						this.props.enqueueSnackbar('申请成功, 请留意您的邮箱, 我们会尽快联系到您.', {
								variant: 'success',
							}
						);
						this.props.updateUserInfo();
						this.handleClose();
						break;
					case "2":
						this.props.enqueueSnackbar("数量不足, 无法兑换", {
								variant: 'error',
							}
						);
						break;
				}
			})
		}

	};

	componentWillReceiveProps(nextProps) {
		this.setState({open: nextProps.open});
	}

	handleClickOpen = () => {
		this.setState({
			open: true
		})
	};

	handleClose = () => {
		this.setState({
			open: false
		})
	};

	render() {
		return (
			<Dialog
				onClose={this.handleClose}
				aria-labelledby="customized-dialog-title"
				open={this.state.open}>
				<DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
					兑换更多
				</DialogTitle>
				<DialogContent dividers style={{minWidth: '400px'}}>
					<Typography gutterBottom>
						兑换为优惠码(每次兑换为1个):
					</Typography>
					<Typography gutterBottom>
						或兑换为现金(每次兑换为3个):
					</Typography>
					<GridContainer>
						<GridItem xs={12} sm={6} md={6} lg={6}>
							<Button color={"rose"} onClick={this.toShowExchangeSubmitProme}>
								申请兑换优惠码
							</Button>
						</GridItem>
						<GridItem xs={12} sm={6} md={6} lg={6}>
							<Button color={"rose"} onClick={this.toShowExchangeSubmitCash}>
								申请兑换现金
							</Button>
						</GridItem>
					</GridContainer>

				</DialogContent>
			</Dialog>
		);
	}
}

export default (withSnackbar)(UserChangeDialog);